<template>
    <div class="shengqingtixian">
        <div class="tit">申请提现</div>
        <div class="msg">您的账户余额满100元即可申请提现，申请提现均按照账户余额结算，无任何其他费用</div>
        <el-form ref="form" label-width="100px" class="demo-ruleForm">
            <el-form-item label="您的账户：">{{ userInfo.nickName }}</el-form-item>
            <el-form-item label="账户余额：">{{ userInfo.balance }}元</el-form-item>
            <el-form-item label="银行账户：">
                <div>为方便我们向您汇款，银行卡号请填写 <b>开户银行所在地</b> 和 <b>支行详细名称</b></div>
                <el-table :data="[bankInfo]">
                    <el-table-column prop="bank" label="银行名称"></el-table-column>
                    <el-table-column label="银行卡/微信、支付宝二维码">
                        <template #default="scope">
                            <div class="paymentMethod">
                                <div v-if="scope.row.account">银行卡<br/>{{ scope.row.account }}</div>
                                <div v-if="scope.row.aliyCode">支付宝支付<br/><el-image :preview-src-list="[baseUrl+scope.row.aliyCode]" :src=" baseUrl+scope.row.aliyCode" alt=""/></div>
                                <div v-if="scope.row.wxCode">微信支付<br/><el-image :preview-src-list="[baseUrl+scope.row.wxCode]" :src="baseUrl+scope.row.wxCode" alt=""/></div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" v-if="Object.keys(bankInfo).length">
                        <template>
                            <span style="color: blue;cursor: pointer;" @click="addBackShow = true;bankInfo.type = tixianTypeDefault">编辑</span>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="addBank" v-if="!Object.keys(bankInfo).length" @click="addBackShow = true">添加银行卡，微信，支付宝二维码</div>
            </el-form-item>
            <el-form-item label="提现金额：">
                <el-input type="number" placeholder="提现金额" v-model="tixian_form.money"></el-input>
                <span style="color: red">提现金额必须为300的倍数</span>
            </el-form-item>
            <el-form-item label="手机号：">
                <el-input type="tel" placeholder="手机号" v-model="tixian_form.phone"></el-input>
            </el-form-item>
            <el-form-item label="支付密码：">
                <el-input placeholder="支付密码" v-model="tixian_form.payPwd"></el-input>
            </el-form-item>
            <el-form-item label="">
                <el-button type="primary" @click="applyWithdrawal">申请提现</el-button>
            </el-form-item>
        </el-form>
        
        <el-dialog title="添加银行卡，微信，支付宝二维码" :visible.sync="addBackShow" :append-to-body="true"
            custom-class="bank-dialog">
            <el-form ref="rruleForm" :model="bankInfo" :rules="rules" label-width="180px">
                <el-form-item label="开户真实姓名:" prop="name">
                    <el-input v-model="bankInfo.name"></el-input>
                </el-form-item>
                <el-form-item label="银行卡号:" prop="account">
                    <el-input v-model="bankInfo.account"></el-input>
                </el-form-item>
                <el-form-item label="选择银行:" prop="bank">
                    <el-input v-model="bankInfo.bank"></el-input>
                </el-form-item>
                <el-form-item label="开户行所在地:" prop="bankAdress">
                    <el-input v-model="bankInfo.bankAdress"></el-input>
                </el-form-item>
                <el-form-item label="支行名:" prop="bankBreach">
                    <el-input v-model="bankInfo.bankBreach"></el-input>
                </el-form-item>
                <el-form-item label="微信支付宝二维码:">
                    <div style="display: flex">
                        <el-upload v-loading="wx_loading" style="margin-right: 20px" action :auto-upload="false" :show-file-list="false" :on-change="upLoadImg_wx">
                            <img v-if="bankInfo.wxCode" :src="baseUrl+bankInfo.wxCode" class="payImg"/>
                            <i v-else class="el-icon-plus avatar-uploader-icon">微信二维码</i>
                        </el-upload>
                        <el-upload v-loading="aliy_loading" action :auto-upload="false" :show-file-list="false" :on-change="upLoadImg_aliy">
                            <img v-if="bankInfo.aliyCode" :src="baseUrl+bankInfo.aliyCode" class="payImg"/>
                            <i v-else class="el-icon-plus avatar-uploader-icon">支付宝二维码</i>
                        </el-upload>
                    </div>
                </el-form-item>
                <el-form-item label="默认提现方式:">
                    <el-select v-model="tixianTypeDefault" placeholder="请选择" @change="val=>bankInfo.type = val">
                        <el-option v-for="item in tixianType" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="saveBankInfo">确定</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
import {
    settleConfig_addAccount,
    settleConfig_querySettleInfo,
    settle_updateAccount,
    settle_apply,
} from "@/api/chongzhi";
import {queryUuIdInfo, getInfo} from "@/api/common";

export default {
    data() {
        return {
            
            baseUrl: process.env.VUE_APP_BASE_API + 'stage-api/',
            
            userInfo: {},
            
            wx_loading: false,
            aliy_loading: false,
            
            addBackShow: false,
            // 银行卡配置信息展示
            bankInfo: {
                name: '',
                account: '',
                bank: '',
                bankAdress: '',
                bankBreach: '',
                type: "",
                id: "",
                
                // money: "",
                // payPwd: "",
                // phone: "",
                // realmoney: "",
                // status: "0",
            },
            rules: {
                name: [
                    {required: true, message: "请输入开户真实姓名", trigger: "blur",},
                ],
                account: [
                    {required: true, message: "请输入银行卡号", trigger: "blur",},
                ],
                bank: [
                    {required: true, message: "请选择银行", trigger: "blur",},
                ],
                bankAdress: [
                    {required: true, message: "请输入开户行所在地", trigger: "blur",},
                ],
                bankBreach: [
                    {required: true, message: "请输入支行名", trigger: "blur",},
                ],
                
            },
            tixianType: [
                {label: '银行卡', value: 'bankpay'},
                {label: '支付宝', value: 'alipay'},
                {label: '微信', value: 'wxpay'},
            ],
            tixianTypeDefault: 'bankpay',
            
            // 提现表单
            tixian_form: {
                account: "", //账户
                money: "300", //提现金额
                payPwd: "123456", //登录密码
                phone: "", //电话
                realmoney: "", //实际金额
                status: "0", //昨天
                type: "", //结算方式
            },
        };
    },
    mounted() {
        this.getBankList();
        
        this.getInfo()
    },
    methods: {
        getInfo() {
            getInfo().then(res => {
                let {nickName, phonenumber, userAccount: {balance}} = res.data.user
                this.userInfo = {nickName, phonenumber, balance}
                this.tixian_form.phone = phonenumber
            })
        },
        // 获取银行卡配置列表
        getBankList() {
            settleConfig_querySettleInfo().then((res) => {
                // this.bankInfo = res.data
                Object.assign(this.bankInfo, res.data);
                this.tixian_form.type = this.tixianTypeDefault = res.data.type.value
            });
        },
        // 保存/编辑银行卡配置
        saveBankInfo() {
            // this.addBackShow = false
            // if(!this.bankInfo.name){
            //     this.$message.success("请输入开户真实姓名");
            //     return;
            // }
            
            this.$refs.rruleForm.validate((valid) => {
                if (valid) {
                    let fn = this.bankInfo.id
                        ? settle_updateAccount
                        : settleConfig_addAccount;
                    fn(this.bankInfo).then((res) => {
                        console.log("saveBankInfo", res);
                        this.$message.success("操作成功");
                        this.addBackShow = false;
                        this.getBankList();
                    });
                }
            });
            
        },
        
        // editBank(){
        // 	this.addBackShow = true
        // 	this.bankInfo.type = 'wxpay'
        // 	this.form = this.bankInfo
        
        // },
        // 申请提现
        applyWithdrawal() {
            let {money, phone, payPwd} = this.tixian_form;
            
            if (money === "" || !isMultipleOf100(money)) {
                return this.$message.error("提现金额必须是100的倍数");
            }
            if (phone.length !== 11) {
                return this.$message.error("请输入正确的手机号");
            }
            if (!payPwd) {
                return this.$message.error("请输入支付密码");
            }
            
            // this.tixian_form.account = this.bankInfo.account;
            this.tixian_form.account = this.bankInfo.id;
            this.tixian_form.realmoney = this.tixian_form.money;
            
            this.tixian_form.type = this.tixianTypeDefault
            
            settle_apply(this.tixian_form).then((res) => {
                console.log("res", res);
                if (res.code === 200) {
                    this.getInfo()
                    this.$message.success('提现申请已提交');
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        async upLoadImg_wx(file) {
            // this.form.wxCode = URL.createObjectURL(file.raw)
            this.wx_loading = true;
            
            let bizId = await queryUuIdInfo();
            const data = {file: file.raw};
            let params = `?bizId=${bizId}&fileType=pay_code&number=1`;
            this.$utils.upLoadFile(params, data).then((res) => {
                this.wx_loading = false;
                console.log("upLoadFile", res);
                this.bankInfo.wxCode = res.data.urls;
            });
        },
        async upLoadImg_aliy(file) {
            // this.form.aliyCode = URL.createObjectURL(file.raw)
            this.aliy_loading = true;
            
            let bizId = await queryUuIdInfo();
            const data = {file: file.raw};
            let params = `?bizId=${bizId}&fileType=pay_code&number=1`;
            this.$utils.upLoadFile(params, data).then((res) => {
                this.aliy_loading = false;
                console.log("upLoadFile", res);
                this.bankInfo.aliyCode = res.data.urls;
            });
        },
    },
};

function isMultipleOf100(number) {
    return number % 300 === 0;
}
</script>

<style lang="scss" scoped>
.paymentMethod {
    > div {
        border-bottom: 1px solid #ccc;
        padding: 20px 0;
        color: red;
        
        .el-image {
            width: 100px;
            height: 100px;
            vertical-align: top;
        }
    }
}

.shengqingtixian {
    /* 页面标题：品牌蓝渐变徽章样式，一眼就能认出是标题 */
    > .tit {
        display: inline-block;
        padding: 8px 18px;
        background: linear-gradient(135deg, #2899df 0%, #1a7fc4 100%);
        color: #fff;
        font-size: 18px;
        font-weight: bold;
        letter-spacing: 1px;
        border-radius: 6px;
        margin-bottom: 4px;
        box-shadow: 0 2px 8px rgba(40, 153, 223, 0.25);
    }

    /* 顶部提示：橙黄警示样式，与正文区分开 */
    > .msg {
        display: block;
        border: 1px solid #ffe0b3;
        border-left: 4px solid #e6a23c;
        background: #fdf7ec;
        color: #b88230;
        padding: 10px 14px;
        margin: 12px 0 18px;
        font-size: 13px;
        line-height: 1.8;
        border-radius: 4px;
    }

    .addBank {
        cursor: pointer;
        color: #026bb7;
    }

    /* 表单标签：品牌蓝加粗，与输入内容一眼区分 */
    .demo-ruleForm {

        :deep(.el-form-item__label) {
            color: #2899df;
            font-weight: 700;
        }

        /* 账户余额：金额用红色加粗突出 */
        > .el-form-item:nth-child(2) {

            :deep(.el-form-item__content) {
                color: #e92728;
                font-weight: 700;
                font-size: 16px;
            }
        }

        /* 银行账户表格：表头「银行名称」与里面的银行名统一用品牌蓝 */
        :deep(.el-table th:first-child),
        :deep(.el-table td:first-child) {
            color: #2899df;
            font-weight: 700;
        }
    }
}

.payImg {
    width: 100px;
    height: 100px;
    object-fit: cover;
    border: 1px solid #333;
}

i.el-icon-plus {
    display: flex;
    flex-direction: column;
    border: 1px solid gray;
    width: 100px;
    height: 100px;
    justify-content: center;
}

i.el-icon-plus::before {
    font-size: 28px;
    margin-bottom: 15px;
}

/* ===== 移动端适配（屏幕小于 1200px 即生效） ===== */
@media (max-width: 1200px) {
    .shengqingtixian {

        /* 顶部提示：占满整行，内边距收小 */
        > .msg {
            padding: 10px 12px;
            margin: 12px 0 14px;
        }

        /* 标题徽章在窄屏收小一号 */
        > .tit {
            padding: 7px 14px;
            font-size: 16px;
        }

        /* 主表单：标签在上、控件在下 */
        .demo-ruleForm {

            :deep(.el-form-item) {
                display: block;
                margin-bottom: 14px;
            }

            :deep(.el-form-item__label) {
                float: none;
                display: block;
                width: auto !important;
                padding: 0 0 6px;
                line-height: 1.6;
                text-align: left;
            }

            :deep(.el-form-item__content) {
                margin-left: 0 !important;
                line-height: 1.6;
            }

            /* 输入框占满整行，右侧提示文字自动换到下一行 */
            :deep(.el-input) {
                width: 100% !important;
                max-width: 100%;
            }

            /* 提交按钮独占一行 */
            :deep(.el-form-item:last-child) {
                margin-top: 20px;
            }
        }
    }
}
</style>

<style lang="scss">
/* 移动端：添加银行卡弹窗（append-to-body，需全局样式）表单改为上下结构 */
@media (max-width: 1200px) {
    .bank-dialog {

        .el-form-item {
            display: block;
            margin-bottom: 14px;
        }

        .el-form-item__label {
            float: none;
            display: block;
            width: auto !important;
            padding: 0 0 6px;
            line-height: 1.6;
            text-align: left;
            /* 标签：品牌蓝加粗，与输入内容区分 */
            color: #2899df;
            font-weight: 700;
        }

        .el-form-item__content {
            margin-left: 0 !important;
            line-height: 1.6;
        }

        .el-input,
        .el-select {
            width: 100% !important;
            max-width: 100%;
        }

        /* 二维码上传：两个上传框紧凑排列 */
        .el-form-item__content>div {
            display: flex;
            gap: 12px;
        }
    }
}
</style>
